"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getHexValidator = void 0;
var regexFormat = /^0x[\da-f]/i;
var ErrorMessages;
(function (ErrorMessages) {
    ErrorMessages["Format"] = "Must be valid hexadecimal number";
    ErrorMessages["Bounds"] = "Input must be ";
    ErrorMessages["BoundsDefault"] = "Input must be within bounds";
})(ErrorMessages || (ErrorMessages = {}));
var format = {
    hex: regexFormat,
};
exports.getHexValidator = function () { return ({
    getRjsfValidation: function () { return format; },
    getInvalidFormatErrorMessage: function () { return ErrorMessages.Format; },
    getBoundsErrorMessage: function (comparison, value) {
        return comparison && value
            ? ErrorMessages.Bounds + comparison + " " + value
            : ErrorMessages.BoundsDefault;
    },
    getFormatValidation: function () { return ({
        name: "format",
        message: exports.getHexValidator().getInvalidFormatErrorMessage(),
    }); },
    getMinValidation: function (comparison, value) { return ({
        name: "minimum",
        message: "" + exports.getHexValidator().getBoundsErrorMessage(comparison, value),
    }); },
    getMaxValidation: function (comparison, value) { return ({
        name: "maximum",
        message: "" + exports.getHexValidator().getBoundsErrorMessage(comparison, value),
    }); },
}); };
